<template>
    <div class="container" style="padding-top: 10px" v-show="shop.id">
        <div class="el-card box-card is-always-shadow">
            <div class="el-card__header">
                <div class="clearfix">
                    <span>Ordenes por Cuotas</span>
                </div>
            </div>
            <form :model="form" label-width="120px" @submit.prevent="onSubmit">
                <div class="el-card__body">
                    <div class="row">
                        <div class="col-md-12">
                            <img
                                class="profile-user-img img-responsive img-circle"
                                v-bind:src="avatar"
                                alt="User profile picture"
                            />
                            <h3 class="profile-username text-center">
                                {{ employee.profiles.first_name }}
                                {{ employee.profiles.first_surname }}
                                {{ employee.profiles.second_surname }}
                            </h3>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group text-left">
                                <label> Cédula</label>
                                <input
                                    class="form-control"
                                    v-validate="'required'"
                                    name="identification"
                                    type="text"
                                    v-model.trim="form.identification"
                                    autocomplete="off"
                                    required
                                />
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="msolicitado"
                                    >Monto a Facturar</label
                                >
                                <money
                                    v-model="form.subtotal"
                                    class="form-control"
                                    :max="balance"
                                >
                                </money>
                                <small
                                    id="msolicitadoH"
                                    class="form-text text-muted"
                                    >Monto a solicitar por la oferta. Monto
                                    maximo de credito
                                    {{ balance | currency }}.</small
                                >
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="msolicitado">Descripción</label>
                                <textarea
                                    type="text"
                                    class="form-control"
                                    v-model="form.description"
                                ></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="text-right">
                        <el-button type="danger" @click="resetForm"
                            >Cancelar</el-button
                        >
                        <el-button
                            type="primary"
                            @click="onSubmit"
                            :icon="isLoading ? 'el-icon-loading' : ''"
                            :disabled="isLoading"
                        >
                            Continuar
                        </el-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import moment from "moment";
export default {
    name: "pending-orders-add",
    components: {},
    data() {
        return {
            respomse: {
                transactions: {
                    id: "",
                },
                request: {
                    identification: "",
                    total_splits: "",
                    next_due: "",
                    total: "",
                },
                client: "",
                subtotal: "",
                tax: "",
            },
            shop: {},
            balance: 0,
            dayTotal: 0,
            employeeId: 0,
            avatar: "https://via.placeholder.com/150",
            employee: {
                profiles: {
                    first_name: "",
                    first_surname: "",
                    second_surname: "",
                },
            },
            form: {
                identification: "",
                subtotal: "",
                shop_id: "",
                description: "",
                date: moment().format("YYYY-MM-DD"),
                employee_id: "",
            },
            isLoading: false,
            labels: {
                identification: "Cedula",
                subtotal: "Monto a Facturar",
                date: "fecha",
                employee_id: "Empleado",
            },
        };
    },
    async created() {
        this.getShops();
    },
    watch: {
        "form.subtotal": function (val) {
            var amount = this.form.subtotal;

            // if(amount > this.balance){
            //     this.form.subtotal = this.balance;
            // }
        },
        "form.identification": function (val) {
            if (this.form.identification.length == 11) {
                this.getUser();
                this.getCreditLimit();
            } else {
                this.setProfileNull();
            }
        },
    },
    methods: {
        setProfileNull() {
            this.employee.profiles.first_name = "";
            this.employee.profiles.first_surname = "";
            this.employee.profiles.second_surname = "";
            this.avatar = "https://via.placeholder.com/150";
        },
        getUser() {
            axios
                .get(
                    `${API_URL}/users?q=(identification:${this.form.identification})&relationships=profiles,employees`
                )
                .then(({ data }) => {
                    if (data.length >= 1) {
                        this.employee = data[0];
                        this.form.employee_id = this.employee.employees.id;
                        this.avatar =
                            "https://app.cashdepotint.com/avatars/" +
                            this.employee.employees.id +
                            ".jpg";
                    } else {
                        this.setProfileNull();
                    }
                });
        },
        getDayTotal(employeeId) {
            const date = moment().format("YYYY-MM-DD");
            axios
                .get(`${API_URL}/orders/employee-total/${employeeId}/${date}`)
                .then((res) => {
                    this.dayTotal = res.data.sum;
                    this.balance = this.shop.day_limit - this.dayTotal;
                });
        },
        async onSubmit() {
            this.isLoading = true;
            if (!this.shop.id || !this.form.subtotal) {
                this.isLoading = false;
                return;
            }

            const formData = Object.entries(this.form);

            if (
                formData.some((entry) => {
                    if (
                        !entry[1] &&
                        entry[0] != "status" &&
                        entry[0] != "itbis" &&
                        entry[0] != "offer_id"
                    ) {
                        const label = this.labels[entry[0]] || entry[0];
                        this.$notify({
                            title: "Error",
                            message: `el campo: ${label} es requerido`,
                            type: "error",
                        });
                        this.isLoading = false;
                        return !entry[1];
                    }
                })
            ) {
                this.isLoading = false;
                return;
            }

            axios
                .post(`${API_URL}/orders/requests`, this.form)
                .then(({ data }) => {
                    window.location.replace("/pending-orders");
                })
                .catch((error) => {
                    var message = error.response.data.status.message;
                    this.$notify({
                        title: "Error",
                        message: message,
                        type: "error",
                    });
                    this.isLoading = false;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        getShops() {
            this.shop = this.$store.state.user;
            this.form.shop_id = this.$store.state.user.id;
            this.form.subtotal = 0;
        },

        getCreditLimit() {
            if (!this.form.identification) {
                return;
            }

            const amount = this.form.subtotal;
            axios
                .get(
                    `${API_URL}/employees/${this.form.identification}/limit_credit`
                )
                .then(({ data }) => {
                    if (data) {
                        this.incomeAmount = data.monthlyIncome * 1;
                        //this.balance = data.available_amount * 1;
                        this.employeeId = data.employee_id;
                        this.form.employee_id = data.employee_id;
                        this.getDayTotal(this.employeeId);
                    }
                })
                .catch((e) => {});
        },
        resetForm() {
            window.location.replace("/pending-orders");
        },
    },
};
</script>
